<template>
  <div>
    <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
      <div>搜索</div>
      <br />
      <a-form layout="inline" ref="dataForm">
        <a-form-item label="姓名">
          <a-input v-model="dataForm.name" placeholder="请输入姓名"> </a-input>
        </a-form-item>
        <a-form-item label="工种">
          <a-select
            style="width: 250px"
            placeholder="请选择工种"
            v-model="dataForm.work_type"
            allowClear
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option
              :value="v.id"
              v-for="v in word_type_arr"
              :key="v.id"
            >
              {{ v.title || "未命名" }}
            </a-select-option>
            <!-- <a-select-option value="3"> 其他 </a-select-option> -->
          </a-select>
        </a-form-item>
        <a-form-item label="分包单位">
          <a-select
            style="width: 250px"
            show-search
            placeholder="请选择分包单位"
            option-filter-prop="children"
            :filter-option="filterOption"
            v-model="dataForm.company_id"
            allowClear
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option :value="v.id" v-for="v in company_arr" :key="v.id">
              {{ v.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="职务">
          <a-input placeholder="请输入职务" v-model="dataForm.duties"></a-input>
        </a-form-item>
        <a-form-item label="培训结果">
          <a-select
            style="width: 200px"
            v-model="dataForm.pass_type"
            allowClear
            placeholder="培训结果"
            :disabled="!!dataForm.color"
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option value="1"> 不合格 </a-select-option>
            <a-select-option value="2"> 及格 </a-select-option>
            <a-select-option value="3"> 优秀 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="入场时间">
          <a-range-picker
            :getCalendarContainer="getCalendarContainer()"
            valueFormat="YYYY-MM-DD"
            v-model="dataForm.jointime"
          />
        </a-form-item>
        <a-form-item label="健康状况">
          <a-select
            style="width: 200px"
            v-model="dataForm.health_level"
            allowClear
            placeholder="健康状况"
            :disabled="!!dataForm.color"
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option value="1"> 健康 </a-select-option>
            <a-select-option value="2"> 一般 </a-select-option>
            <a-select-option value="3"> 较差 </a-select-option>
            <a-select-option value="0"> 未体检 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="二维码颜色">
          <a-select
            style="width: 200px"
            v-model="dataForm.color"
            allowClear
            placeholder="二维码颜色"
            @change="changeColor"
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option value="1"> 绿码 </a-select-option>
            <a-select-option value="2"> 黄码 </a-select-option>
            <a-select-option value="3"> 红码 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="handleReset"> 重置 </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card style="border: none; border-radius: 12px" title="分包单位">
      <div slot="extra">
        <a-button
          icon="check-square"
          @click="buqian()"
          type="primary"
          :disabled="
            dataListSelections.length == 0 ||
            dataListSelections.findIndex((v) => !v.train_id) > -1
          "
          :loading="jyrLoading"
          v-permission="['file:filesprint:buqian']"
        >
          批量补签
          {{
            dataListSelections.findIndex((v) => !v.train_id) > -1
              ? "(勾选数据中包含未培训人员)"
              : ""
          }}
        </a-button>
        <a-button
          icon="redo"
          @click="query"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          刷新数据
        </a-button>
      </div>
      <a-table
        filterMultiple
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        :scroll="{ x: 1500 }"
        rowKey="id"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onSelect: onSelect,
          onChange: onSelectChange,
          onSelectAll: onSelectAll,
        }"
      >
        <a
          slot="pass_type_transformed"
          slot-scope="text, record"
          :style="{
            color: !record.pass_type
              ? '#ccc'
              : record.pass_type == 1
              ? '#EA1313'
              : '#0073FF',
          }"
        >
          {{ text || "未培训" }}
        </a>
        <span
          slot="health_level_name"
          slot-scope="text, record"
          :style="{
            color:
              record.health_level == 3
                ? '#EA1313'
                : record.health_level == 2
                ? '#FFA500'
                : record.health_level == 1
                ? '#4DCC66'
                : '#ccc',
          }"
        >
          {{ text }}
        </span>
        <span slot="company_name" slot-scope="text">
          <span v-if="text">{{ text }}</span>
          <a-tag color="red" v-else> 未分配分包单位 </a-tag>
        </span>
        <span slot="health_level" slot-scope="text, record">
          <a-badge
            :status="
              text == 1 && record.pass_type != 1
                ? 'success'
                : text == 2
                ? 'warning'
                : 'error'
            "
          >
          </a-badge>
          <span
            :style="{
              color:
                text == 1 && record.pass_type != 1
                  ? '#4DCC66'
                  : text == 2
                  ? '#FFA500'
                  : '#EA1313',
            }"
            >{{
              text == 1 && record.pass_type != 1
                ? "绿码"
                : text == 2
                ? "黄码"
                : "红码"
            }}</span
          >
        </span>
        <span slot="train_id" slot-scope="text, record">
          <span v-if="!text" style="color: #ccc">未培训</span>
          <span v-else-if="!record.jyr1 || !record.jyr2 || !record.jyr3"
            >未签字</span
          >
          <span v-else style="color: #4dcc66;cursor: pointer;" @click="buqian(record)">已签字</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-space>
            <!-- <a-button size="small" type="link">删除</a-button> -->
            <a-button
              size="small"
              type="link"
              v-if="!record.sign || !record.finger"
              @click="sign(record)"
              v-permission="['file:filesprint:sign']"
              >人员签字</a-button
            >
            <a-button
              size="small"
              type="link"
              style="color: #666"
              v-else
              @click="sign(record)"
              v-permission="['file:filesprint:sign']"
              >查看人员签字</a-button
            >
            <a-button
              size="small"
              type="link"
              @click="printCode(record)"
              v-permission="['file:filesprint:printcode']"
              >打印二维码</a-button
            >
          </a-space>
        </span>
      </a-table>
      <div style="margin-top: 20px; float: left">
        <a-button
          @click="exportHandleSeft()"
          :loading="exportLoading"
          icon="download"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          导出
        </a-button>
      </div>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :pageSizeOptions="pageSizeOptions"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
    <SignPop ref="signPop" @query="getDataList"></SignPop>
    <ExprtFile
      ref="exprtFile"
      :loading="blank_loading"
      :blank_list="blank_list"
      @confirmExport="confirmExport"
    ></ExprtFile>
    <Jyr ref="jyr" @jyrok="jyrok"></Jyr>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import { configDetailAll } from "@/request/person";
import { setcodetime } from "@/request/file";
import { companyAll } from "@/request/company";
import Saveprint from "@/utils/saveprint/index";
import SignPop from "./components/signPop.vue";
import ExprtFile from "./components/exportFile";
import PrintCode from "@/utils/printCode";
import instance from "@/request/request";
import Jyr from "./components/jyr";
export default {
  mixins: [viewModule],
  components: { SignPop, ExprtFile, Jyr },
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 60,
          align: "center",
          customRender: (text, record, index) => {
            return (this.page - 1) * this.limit + index + 1;
          },
        },
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 100,
          fixed: "left",
        },
        {
          title: "分包单位",
          dataIndex: "company_name",
          key: "company_name",
          align: "center",
          fixed: "left",
          width: 150,
          scopedSlots: { customRender: "company_name" },
        },
        {
          title: "年龄",
          dataIndex: "age",
          key: "age",
          align: "center",
          width: 80,
        },
        {
          title: "工种",
          dataIndex: "work_name",
          key: "work_name",
          align: "center",
          width: 200,
        },
        {
          title: "性别",
          dataIndex: "gender_name",
          key: "gender_name",
          align: "center",
          width: 80,
        },
        {
          title: "是否退场",
          dataIndex: "is_exit",
          key: "is_exit",
          align: "center",
          width: 100,
          customRender: (text) => (text == 0 ? "否" : "是"),
        },
        {
          title: "培训结果",
          dataIndex: "pass_type_transformed",
          key: "pass_type_transformed",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "pass_type_transformed" },
        },
        {
          title: "健康状况",
          dataIndex: "health_level_name",
          key: "health_level_name",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "health_level_name" },
        },
        {
          title: "二维码颜色",
          dataIndex: "health_level",
          key: "health_level",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "health_level" },
        },
        {
          title: "管理员是否签字",
          dataIndex: "train_id",
          key: "train_id",
          align: "center",
          width: 150,
          scopedSlots: { customRender: "train_id" },
        },
        {
          title: "入场时间",
          dataIndex: "create_time",
          key: "create_time",
          align: "center",
          width: 200,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      word_type_arr: [],
      company_arr: [],
      mixinViewModuleOptions: {
        getDataListURL: "/files/page",
      },
      dataForm: {
        name: "",
        work_type: undefined,
        company_id: undefined,
        duties: "",
        jointime: [],
        pass_type: undefined,
        health_level: undefined,
        color: undefined
      },
      Save: null,
      exportLoading: false,
      pr: null,
      blank_loading: false,
      blank_list: [],
      jyrLoading: false, //补签loading
    };
  },
  created() {
    //所有工种
    configDetailAll({ type: "work_type" }).then((res) => {
      this.word_type_arr = res.data;
    });
    //所有分包单位
    companyAll().then((res) => {
      this.company_arr = res.data;
    });
  },
  methods: {
    getCalendarContainer(trigger){
      return trigger => trigger.parentNode;
    },
    //切换二维码颜色
    changeColor(e){
      if(!!e){
        this.dataForm.pass_type = undefined
        this.dataForm.health_level = undefined
      }
    },
    //补签按钮
    buqian(e) {
      this.$refs.jyr.init(e);
    },
    //补签回调
    jyrok(e) {
      this.jyrLoading = true;
      instance
        .post("/files/jyrbq", {
          ...e,
          ids: this.dataListSelections.map((v=> v.train_id)),
        })
        .then(() => {
          this.$message.success("补签成功");
          this.getDataList();
        })
        .finally(() => {
          this.jyrLoading = false;
        });
    },
    //获取空白模板
    getBlank() {
      this.blank_list = [];
      this.blank_loading = true;
      let a = setTimeout(() => {
        clearTimeout(a);
        instance
          .get("/filesBlank/list")
          .then((res) => {
            this.blank_list = res.data.list;
          })
          .finally(() => {
            this.blank_loading = false;
          });
      }, 400);
    },
    //打印二维码
    printCode(record) {
      if (!this.pr) {
        this.pr = new PrintCode();
        this.pr.setErrorCallback((res) => {
          this.$notification.error({
            message: "打印失败",
            description: res.message,
          });
        });
        this.pr.setSuccessback(() => {
          setcodetime({ id: record.id }).then(() => {
            this.$message.success(`打印【${record.name}】二维码成功`);
          });
        });
      }
      this.pr.print(
        record.name,
        record.company_name,
        record.code_url,
        record.company_address
      );
    },
    handleReset() {
      this.dataForm = {
        name: "",
        work_type: undefined,
        company_id: undefined,
        duties: "",
        jointime: [],
        pass_type: undefined,
        health_level: undefined,
        color: undefined
      };
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // onSelectChange(selectedRowKeys, selectedRows) {
    //   this.selectedRowKeys = selectedRowKeys;
    //   this.dataListSelections = selectedRows;
    // },
    //签字
    sign(record, disabled = false) {
      this.$refs.signPop.init(record, disabled);
    },
    //导出
    exportHandleSeft() {
      if (this.dataListSelections.length == 0)
        return this.$message.warning("至少勾选一条数据");
      this.$refs.exprtFile.init();
      this.getBlank();
    },
    //确认导出
    confirmExport(e) {
      const default_list = e.filter((v) => v.indexOf("6-") === -1);
      //组合已选中的空白模板
      const list = e
        .filter((v) => v.indexOf("6-") > -1)
        .map((v) => {
          const id = v.substr(2, v.length);
          return this.blank_list.find((v) => v.id == id);
        })
        .map((v) => {
          return {
            id: "6-" + v.id,
            blank_title: v.title,
          };
        });
      if (!this.Save) {
        this.Save = new Saveprint();
        this.Save.setExportState((res) => {
          this.exportLoading = res.exportLoading; //是否在导出
          if (res.exportSuccess) {
            const key = `open${Date.now()}`;
            this.$notification["success"]({
              message: "档案导出成功",
              description: `已保存至: ${res.outputFolderPath}`,
              duration: 0,
              key: key,
            });
          }
        });
      }
      this.Save.fileInit(this.dataListSelections, [...default_list, ...list]);
    },
  },
};
</script>

<style>
</style>